import { takeEvery, put, select } from 'redux-saga/effects'
import { difference } from 'ramda'

import { DELETE_SINGLE_CONDITION } from 'actions/feature/conditions'
import { DELETE_FUNCTION } from 'actions/feature/functions'
import { DELETE_OUTPUT_NODE } from 'actions/feature/outputs'
import { DELETE_LOGIC_NODE } from 'actions/feature/logicNodes'
import { removeComponentMeta } from 'actions/navigator'

import { getDeleteFunctionOrLogicNodeData } from 'selectors/feature/featureNavigator'

export function* watchDeleteSingleCondition() {
  yield takeEvery(DELETE_SINGLE_CONDITION, deleteSingleCondition)
}

function* deleteSingleCondition({ uri }) {
  yield put(removeComponentMeta([uri]))
}

export function* watchDeleteOutputNode() {
  yield takeEvery(DELETE_OUTPUT_NODE, deleteOutputNode)
}

function* deleteOutputNode({ id }) {
  yield put(removeComponentMeta([id]))
}

export function* watchDeleteFunctionOrLogicNode() {
  yield takeEvery(
    [DELETE_FUNCTION, DELETE_LOGIC_NODE],
    deleteFunctionOrLogicNode
  )
}

function* deleteFunctionOrLogicNode() {
  const [
    navigatorKeys,
    outputKeys,
    conditionsKeys,
    queriesKeys,
    functionKeys,
    featureId,
  ] = yield select(getDeleteFunctionOrLogicNodeData)

  const compareList = [
    featureId,
    'history',
    ...outputKeys,
    ...conditionsKeys,
    ...queriesKeys,
    ...functionKeys,
  ]

  const keysToRemove = difference(navigatorKeys, compareList)

  yield put(removeComponentMeta(keysToRemove))
}
